import styled from 'styled-components'

export const StyledFiltersResults = styled.div`
  .error{
    display: block;
    color: red;
    ${({ theme }) => theme.marginY(theme.rem(24))}
  }
`
